import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * A wrapper for form elements
 */
const FormGroup = (props) => {
  const { children, className, label, id, error, ...otherProps } = props;
  const classNames = classnames('form-group', className);
  if (label) {
    return (
      <div {...otherProps} className={classNames}>
        {label && (
          <label className="form-label" htmlFor={id}>
            {label}
          </label>
        )}
        {children}
        <div className="text-error" id={`error-massage-${otherProps.name}`}>{error}</div>
      </div>
    );
  }
  return children;
};

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.string,
  id: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.element, PropTypes.string])),
  ]),
};

FormGroup.defaultProps = {
  className: '',
  label: '',
  id: '',
  error: '',
};

export { FormGroup };
